/* Phones: one Help button for Ollie and WhatsApp. The originals stay in the page and do the work. */
(function () {
  var start = function () {
    var ollie = document.getElementById('ollieLaunch');
    var whatsapp = document.querySelector('.whatsapp-float');
    if (!ollie && !whatsapp) return;

    var box = document.createElement('div');
    box.className = 'isc-help';
    box.innerHTML =
      '<div class="isc-help__menu" id="iscHelpMenu" hidden>' +
        '<button type="button" class="isc-help__item" data-help-ollie><span class="isc-help__av" aria-hidden="true">O</span><span class="isc-help__text"><b>Ask Ollie</b><small>Our product expert</small></span></button>' +
        '<a class="isc-help__item" data-help-whatsapp target="_blank" rel="noopener"><span class="isc-help__av isc-help__av--wa" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 0 1-13.3 7.9L3 21l1.2-4.5A9 9 0 1 1 21 12Z"/></svg></span><span class="isc-help__text"><b>WhatsApp us</b><small>Message our team</small></span></a>' +
      '</div>' +
      '<button type="button" class="isc-help__btn" aria-expanded="false" aria-controls="iscHelpMenu" aria-label="Help: ask Ollie or WhatsApp us"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.4A8.5 8.5 0 1 1 21 12Z"/><path d="M9.8 9.8a2.3 2.3 0 1 1 3.4 2c-.8.4-1.2.9-1.2 1.7"/><path d="M12 16.3h.01"/></svg></button>';
    document.body.appendChild(box);

    var button = box.querySelector('.isc-help__btn');
    var menu = box.querySelector('.isc-help__menu');
    var askOllie = box.querySelector('[data-help-ollie]');
    var message = box.querySelector('[data-help-whatsapp]');

    if (whatsapp) message.href = whatsapp.href;
    else message.hidden = true;

    var setOpen = function (open) {
      /* Ollie's script un-hides its button once it is ready, and some pages keep it hidden */
      askOllie.hidden = !ollie || ollie.hidden;
      menu.hidden = !open;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    button.addEventListener('click', function () { setOpen(menu.hidden); });
    askOllie.addEventListener('click', function () {
      setOpen(false);
      ollie.click();
    });
    message.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('click', function (event) {
      if (!menu.hidden && !box.contains(event.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || menu.hidden) return;
      setOpen(false);
      button.focus();
    });

    document.documentElement.classList.add('isc-help-on');
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
